export default "__VITE_ASSET__8e28ce7f__"